module.exports = __webpack_public_path__ + "img/pow-pos.6dc87d98.png";